import { changeVehicleLocationGetPolicy, changeVehicleLocationApplyBusinessRules } from '@/constants/forms-api.const';
import { RequestServices as _http } from '../common/request.services';
import { IJeopardy, IServiceResponse, InsurancePolicy } from '@/interfaces';
import { QuotePremiumDetails } from '@/interfaces/entities/premium-details.interface';

export interface ApplyRulesRequestOfChangeVehicleLocationUpdateModel {
  quoteSessionId?: string;
  requestQuote?: boolean;
  bindChange?: boolean;
  model?: ChangeVehicleLocationUpdateModel;
}

export interface ChangeVehicleLocationUpdateModel {
  changeEffectiveDate: Date;
  vehicleLocations: VehicleLocation[];
}

export interface VehicleLocation {
  coverageId: string;
  overnightParkingLocationCode: string;
  overnightParkingLocationSuburb: string;
  overnightParkingLocationPostcode: string;
  overnightParkingLocationState: string;
  overnightParkingLocationAddressLine?: string;
}

export interface ApplyRulesResponseOfChangeVehicleLocationViewModel {
  jeopardies: IJeopardy[];
  viewModel: ChangeVehicleLocationViewModel;
}

export interface ChangeVehicleLocationViewModel {
  policyNumber: string;
  quotePremiumDetails: QuotePremiumDetails;
}

export const ChangeVehicleLocationService = {
  /**
   * Get Policy
   *
   * @param quoteSessionId
   */
  getPolicy(quoteSessionId: string): Promise<IServiceResponse<InsurancePolicy>> {
    return _http.HttpGet(changeVehicleLocationGetPolicy.replace('{0}', quoteSessionId));
  },

  /**
   * Apply Business Rules
   *
   * @param request
   */
  applyBusinessRules(
    request: ApplyRulesRequestOfChangeVehicleLocationUpdateModel
  ): Promise<IServiceResponse<ApplyRulesResponseOfChangeVehicleLocationViewModel>> {
    return _http.HttpPost(changeVehicleLocationApplyBusinessRules, request);
  },
};
